import React from 'react'
import 'bootstrap/dist/css/bootstrap.css';
import Timer from '../Timers/Timer';
import TimeInput from '../Timers/TimeInput';
import PermissionWrapper from '../../auth/PermissionWrapper';

class ClientReportHeader extends React.Component {

    render = () => {
        this.props.info('ClientReportHeader.js/render');
        return (
            <tr key={this.props.report.id} className={"mainRow my-0 " + (this.props.active ? "activeTab" : "")}>
                <td className="text-left pointer" onClick={(e) => this.props.selectReport(this.props.report)}>
                    {parseInt(this.props.report.date.substr(5, 2)) + '/' + parseInt(this.props.report.date.substr(8, 2)) + '/' + this.props.report.date.substr(2, 2)}
                </td>
                <td className="pointer" onClick={(e) => this.props.selectReport(this.props.report)}>
                    {this.props.report.securities.length}
                </td>
                <td className="pointer" onClick={(e) => this.props.selectReport(this.props.report)}>
                    {this.props.report.accounts.length}
                </td>
                <td className="pointer" onClick={(e) => this.props.selectReport(this.props.report)}>
                    {this.props.report.reconciled.length}
                </td>
                <td className="pointer" onClick={(e) => this.props.selectReport(this.props.report)}>
                    {this.props.report.unreconciled.length}
                </td>
                <td className="text-left">
                    <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} {...this.state} allowedPermission="Direct Time Input">
                        <TimeInput
                            timeTracking={this.props.report.timeTracking != null && this.props.report.timeTracking.length > 0 ? this.props.report.timeTracking[0] : null}
                            date={this.props.report.date}
                            handleTimeTrackingInput={this.props.handleTimeTrackingInput}
                            reportId={this.props.report.id}
                            timestamp={this.props.report.timestamp}
                            log={this.props.log}
                            info={this.props.info}
                            formatAMPM={this.props.formatAMPM}
                            active={this.props.active}
                            isFieldNull={this.props.isFieldNull}
                        />
                    </PermissionWrapper>
                    <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} {...this.state} allowedPermission="Timer Entry">
                        <Timer
                            timeTracking={this.props.report.timeTracking != null && this.props.report.timeTracking.length > 0 ? this.props.report.timeTracking[0] : null}
                            loadedServerTimestamp={this.props.loadedServerTimestamp}
                            loadedPageTimestamp={this.props.loadedPageTimestamp}
                            handleTimeTracking={this.props.handleTimeTracking}
                            reportId={this.props.report.id}
                            timestamp={this.props.report.timestamp}
                            log={this.props.log}
                            info={this.props.info}
                            formatAMPM={this.props.formatAMPM}
                            active={this.props.active}
                            isFieldNull={this.props.isFieldNull}
                        />
                    </PermissionWrapper>
                </td>
            </tr>
        )
    }
}

export default ClientReportHeader;